(() => {
  const SESSION_KEY = 'souqscent-newsletter-popup-opened';
  const LAUNCHER_DISMISSED_KEY = 'souqscent-newsletter-popup-launcher-dismissed-session';
  const SUCCESS_SEEN_KEY = 'souqscent-newsletter-popup-success-seen';

  function initPopup(root) {
    if (!root || typeof root.show !== 'function') return;
    const launcher = document.querySelector('[data-newsletter-popup-launcher]');
    const openButtons = document.querySelectorAll('[data-newsletter-popup-open]');
    const dismissButtons = document.querySelectorAll('[data-newsletter-popup-dismiss]');
    const successState = root.querySelector('[data-newsletter-popup-success-state]');
    const postedSuccessfully = successState?.value === 'true';
    const phoneNationalInput = root.querySelector('[data-newsletter-popup-phone-national]');
    const phoneFullInput = root.querySelector('[data-newsletter-popup-phone-full]');

    function hideLauncherForSession() {
      sessionStorage.setItem(LAUNCHER_DISMISSED_KEY, 'true');
      launcher?.classList.add('newsletter-popup-launcher--hidden');
    }

    function closeForSession() {
      sessionStorage.setItem(SESSION_KEY, 'true');
      hideLauncherForSession();
      root.hide();
    }

    if (sessionStorage.getItem(LAUNCHER_DISMISSED_KEY) === 'true' && launcher) {
      launcher.classList.add('newsletter-popup-launcher--hidden');
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        sessionStorage.setItem(SESSION_KEY, 'true');
        root.show(button);
      });
    });

    dismissButtons.forEach((button) => {
      button.addEventListener('click', () => {
        hideLauncherForSession();
      });
    });

    root.querySelectorAll('[data-newsletter-popup-close]').forEach((button) => {
      button.addEventListener('click', () => {
        closeForSession();
      });
    });

    if (phoneNationalInput && phoneFullInput) {
      const normalizeQatarPhone = () => {
        const digits = phoneNationalInput.value.replace(/\D/g, '').replace(/^974/, '').slice(0, 8);
        phoneNationalInput.value = digits;
        phoneFullInput.value = digits.length ? `+974${digits}` : '';
      };

      if (phoneFullInput.value) {
        phoneNationalInput.value = phoneFullInput.value.replace(/\D/g, '').replace(/^974/, '').slice(0, 8);
        normalizeQatarPhone();
      }

      phoneNationalInput.addEventListener('input', normalizeQatarPhone);
      root.querySelector('form')?.addEventListener('submit', normalizeQatarPhone);
    }

    const modalCloseButton = root.querySelector('.newsletter-popup__close');
    if (modalCloseButton) {
      modalCloseButton.addEventListener('click', () => {
        if (postedSuccessfully) {
          sessionStorage.setItem(SUCCESS_SEEN_KEY, 'true');
          hideLauncherForSession();
        }
      });
    }

    const shouldOpen = root.dataset.openOnLoad === 'true';
    if (!shouldOpen) return;

    if (postedSuccessfully) {
      if (sessionStorage.getItem(SUCCESS_SEEN_KEY) === 'true') return;

      sessionStorage.setItem(SESSION_KEY, 'true');
      sessionStorage.setItem(SUCCESS_SEEN_KEY, 'true');
      window.setTimeout(() => {
        root.show();
      }, 0);

      if (window.location.search.includes('customer_posted=true')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
      return;
    }

    if (sessionStorage.getItem(SESSION_KEY) === 'true') return;

    window.setTimeout(() => {
      sessionStorage.setItem(SESSION_KEY, 'true');
      root.show();
    }, 5000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('modal-dialog.newsletter-popup').forEach(initPopup);
  });
})();
